// src/routes/AllRoutes.tsx

import { Navigate, Routes, Route } from "react-router-dom";
import { AdminDashboardPage, LoginPage } from "../pages";
import ProtectedRoute from "./ProtectedRoute";
import PublicOnlyRoute from "./PublicOnlyRoute";
import { DEFAULT_ADMIN_ROUTE } from "../features/admin/navigation/routes";

export const AllRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<PublicOnlyRoute><LoginPage /></PublicOnlyRoute>} />
      <Route 
        path="/admin/*"
        element={
          <ProtectedRoute>
            <AdminDashboardPage />
          </ProtectedRoute>
        } 
      />
      <Route path="/dashboard" element={<Navigate to={DEFAULT_ADMIN_ROUTE} replace />} />
      <Route path="*" element={<Navigate to={DEFAULT_ADMIN_ROUTE} replace />} />
    </Routes>
  );
};
